/* eslint-disable react-hooks/exhaustive-deps */
import { EnquiryHandle, RightPanelTabs, RightPanelTabsConfiguration } from '@access-erp/common';
import { ActionCardProps, ActionsProps, IRowNode } from '@access-erp/ui-components';
import { useMemo, useState } from 'react';

import { BundleOutput } from '@/graphql/contracts/_generated_/contracts';
import History from '../components/History/History';

interface UseRightPanelParams {
  selectedHeaderRows: IRowNode<BundleOutput>[];
  gridRef?: EnquiryHandle<BundleOutput>;
}

type ActionButton = {
  config: ActionCardProps;
  isVisible: boolean;
};

export function useRightPanel({ selectedHeaderRows }: UseRightPanelParams) {
  const [isVisibleAddModal, setIsVisibleAddModal] = useState(false);
  const [isVisibleEditModal, setIsVisibleEditModal] = useState(false);
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);

  const actionButtons = useMemo<ActionButton[]>(
    //Uncomment when we implement this functionality
    () => [
      // {
      //   config: {
      //     text: 'Add Bundle',
      //     cardType: CardType.ACTION,
      //     product: Product.ContractsAndBilling,
      //     onClick: () => setIsVisibleAddModal(true),
      //   },
      //   isVisible: true,
      // },
      // {
      //   config: {
      //     text: 'Edit Bundle',
      //     cardType: CardType.ACTION,
      //     product: Product.ContractsAndBilling,
      //     onClick: () => setIsVisibleEditModal(true),
      //   },
      //   isVisible: selectedHeaderRows.length == 1,
      // },
      // {
      //   config: {
      //     text: 'Delete Bundle',
      //     cardType: CardType.DELETE,
      //     product: Product.ContractsAndBilling,
      //     onClick: () => setIsVisibleDeleteModal(true),
      //   },
      //   isVisible: selectedHeaderRows.length > 0,
      // },
    ],
    [selectedHeaderRows],
  );

  const actionsParams: ActionsProps = {
    actionCards: {
      actions: actionButtons.filter((el) => el.isVisible).map((el) => el.config),
    },
  };

  const tabsConfiguration = useMemo<RightPanelTabsConfiguration>(
    () => ({
      [RightPanelTabs.ACTIONS]: actionsParams,
      History: {
        component: <History selectedBundles={selectedHeaderRows} />,
      },
    }),
    [selectedHeaderRows],
  );

  return {
    tabsConfiguration,
    isVisibleAddModal: isVisibleAddModal,
    setIsVisibleAddModal: setIsVisibleAddModal,
    isVisibleEditModal: isVisibleEditModal,
    setIsVisibleEditModal: setIsVisibleEditModal,
    isVisibleDeleteModal: isVisibleDeleteModal,
    setIsVisibleDeleteModal: setIsVisibleDeleteModal,
  };
}
